// Default theme settings configurations

import {ConstantsHandler} from "../../_common/_constant/constants.handler";

export const ThemeSettingsConfig = {
  colorTheme: 'light', // light, semi-light, semi-dark, dark
  layout: {
    style: 'vertical', // style: 'vertical', horizontal,
    pattern: 'fixed' // fixed, boxed, static
  },
  menuColor: 'menu-light', // Vertical: [menu-dark, menu-light] , Horizontal: [navbar-dark, navbar-light]
  navigation: 'menu-collapsible', // menu-collapsible, menu-accordation
  menu: 'expand', // collapse, expand
  header: 'fix', // fix, static
  footer: 'static', // fix, static
  customizer: 'off', // on,off
  buybutton: 'off', // on, off
  headerIcons: {
    maximize: 'on', // on, off
    search: 'on', // on, off
    internationalization: 'on', // on, off
    notification: 'on', // on, off
    email: 'on' // on, off
  },
  brand: {
    brand_name: ConstantsHandler.APP_MENU_TITLE,
    logo: {
      type: 'internal', // internal, url
      value: ConstantsHandler.APP_MENU_ICON // recommended location for custom images
      // type:'url',
      // value:'http://evolvision.com/wp-content/uploads/2018/01/envelope4-green.png'
    },
  },
  vertical_background_color: ConstantsHandler.APP_VERTICAL_BACKGROUND_COLOR,
  defaultTitleSuffix: ''
};
